<template>
  <div id="app">
    <!--<img src="./assets/logo.png">-->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style>
  @import './assets/iconfont/iconfont.css';
</style>



// WEBPACK FOOTER //
// src/App.vue